import type { BatchPreviewTransitionLinkProps } from "./batch-preview-transition-link.type";

import { useTranslation } from "react-i18next";

import { BatchPreviewLink } from "../batch-preview-link";
import { getBatchPreviewTransitionModelKey } from "../batch-preview.helper";

export const BatchPreviewTransitionLink = ({
  customContext,
  type,
  state,
  userId: user_id,
  ids,
  icon,
  onClick,
}: BatchPreviewTransitionLinkProps) => {
  const { t } = useTranslation();
  const model = getBatchPreviewTransitionModelKey(type);

  return (
    <BatchPreviewLink
      customContext={customContext}
      params={{ type, state, user_id, ids: ids.join(",") }}
      icon={icon === "model" ? model : icon}
      onClick={onClick}
    >
      {t(`global:batchPreview.transition.${model}.link`)}
    </BatchPreviewLink>
  );
};
